import React from 'react';

const Stakeholder = ({stakeholder}) => {
    return (
        <div className="item">
            <div className="stakeholder-card">
                <header className="card-header">
                    <img src={`data:image/jpg;base64,${stakeholder.iconBase64}`} alt={stakeholder.iconTag}/>
                </header>
                <div className="card-body">
                    <span className="stakeholder-organization">{stakeholder.titleEn}</span>
                </div>
            </div>
        </div>
    );
};

export default Stakeholder;
